import React, { useEffect, useMemo, useState } from "react";
import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";

import { useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BlockIcon from "@mui/icons-material/Block";
import styled from "@emotion/styled";
import ArticleIcon from "@mui/icons-material/Article";
import axiosInstance from "../utils/axiosConfig";
import useDebounce from "../hooks/useDebounce";
import CustomConfirmationDialog from "./CustomConfirmationDialog";
import filterEmptyPropertiesRecursively from "../utils/filterEmptyPropertiesRecursively";
import SwipeableDrawerComponent from "./SwipeableDrawerComponent ";
import SearchActionComponent from "./reusableComponents/SearchActionComponent";
import CustomFilter, {
  SortPanel,
} from "./reusableComponents/Filter/CustomFilter";
import { BootstrapTooltip } from "./DetailsSidePanelChart";
import { useLocation } from "react-router-dom";
import { validateNumber } from "../utils/formatNumberShort";
import { useSettings } from "../hooks/useSettings";
import MuiIconButton from "./uicomponents/MuiIconButton";
import DataTable from "./DataTable";
import FilteredResults from "./FilteredResults";
import CustomerDetails from "./CustomerDetails";
import { getCountryNamesAndCodes } from "../const/countrylist";
import { countries } from "countries-list";
import { joinedonSortObj } from "../const/sort";
import useQueryParams from "../hooks/useQueryParams ";
import dayjs from "dayjs";
import CommonTableHead from "./CommonTableHead";
import { CustomMenu } from "./Menu";
import { notifyToast } from "../utils/notify";

// on hovering tooltip component
function CustomComponent({ openTickets, totalTickets }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        padding: "5px",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "flex-start",
        gap: "2px",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontSize: "12px",
        }}
      >{`Open tickets - ${openTickets}`}</Typography>
      <Typography
        variant="h6"
        sx={{
          fontSize: "12px",
        }}
      >{`Total tickets - ${totalTickets}`}</Typography>
    </Box>
  );
}

export function TripsComponent({ completeTrips, cancelledTrips, totalTrips }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        padding: "5px",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "flex-start",
        gap: "2px",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontSize: "12px",
        }}
      >{`Complete trips - ${completeTrips}`}</Typography>
      <Typography
        variant="h6"
        sx={{
          fontSize: "12px",
        }}
      >{`Cancelled trips - ${cancelledTrips}`}</Typography>
      <Typography
        variant="h6"
        sx={{
          fontSize: "12px",
        }}
      >{`Total trips - ${totalTrips}`}</Typography>
    </Box>
  );
}

// custom menu
export const StyledMenu = styled((props) => (
  <Menu
    id="basic-button"
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    zIndex: "-1",
    borderRadius: "12px",
    marginTop: "10px",
    minWidth: 180,
    color: "#000",
    // boxShadow: "0px 2px 20px 0px #00000012",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 16,
        color: "#000",
        marginRight: "1.5px",
      },
    },
  },
}));

function Action({
  params,
  toggleDrawer,
  setRiderId,
  handleClick,
  open,
  permissionsSubSection,
  anchorEl,
  handleClose,
  handleConformationDailog,
  isblocked,
  setIsBlocked,
  hideViewDetails = true,
  setRiderName,
}) {
  // css
  const menuIteamBtnStyle = {
    color: "#000",
    fontFamily: "Proxima Nova",
    fontSize: "12px",
    width: "100%",
    fontStyle: "normal",
    justifyContent: "flex-start",
    fontWeight: 500,
    lineHeight: "175%",
  };

  return (
    <>
      <MuiIconButton
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={(e) => {
          setIsBlocked(params?.row?.account_status ?? "");
          handleClick(e, params.row.id);
          setRiderName(params?.row?.full_name);
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MoreVertIcon
          sx={{
            color: "#000",
          }}
        />
      </MuiIconButton>
      <>
        <CustomMenu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          ModalProps={{
            style: {
              zIndex: 1200,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            },
          }}
        >
          {hideViewDetails && (
            <MenuItem
              sx={{
                paddingInline: "10px",
                paddingBlock: "0px",
              }}
            >
              <Button
                sx={menuIteamBtnStyle}
                disableRipple
                disableFocusRipple
                disableElevation
                variant="text"
                startIcon={<ArticleIcon sx={{ color: "#000" }} />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleClose();
                  toggleDrawer("right", true)(e);
                }}
              >
                View details
              </Button>
            </MenuItem>
          )}
          {permissionsSubSection?.UPDATE && (
            <MenuItem>
              <Button
                sx={menuIteamBtnStyle}
                disableRipple
                disableFocusRipple
                disableElevation
                variant="text"
                startIcon={<BlockIcon sx={{ color: "#000" }} />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleClose();
                  handleConformationDailog("block", true);
                }}
              >
                {isblocked === "ACTIVE" ? "Block" : "Unblock"}
              </Button>
            </MenuItem>
          )}

          {permissionsSubSection?.DELETE && (
            <MenuItem>
              <Button
                sx={menuIteamBtnStyle}
                disableRipple
                disableFocusRipple
                disableElevation
                variant="text"
                startIcon={<DeleteIcon sx={{ color: "#000" }} />}
                onClick={(e) => {
                  handleClose();
                  handleConformationDailog("delete", true);
                }}
              >
                Delete
              </Button>
            </MenuItem>
          )}
        </CustomMenu>
      </>
    </>
  );
}

const Customers = () => {
  const {
    setQuery,
    removeQuery,
    getQuery = () => {},
    searchParams,
    setSearchParams,
  } = useQueryParams();

  const countrylist = useMemo(() => getCountryNamesAndCodes(), []);

  const [sort, setSort] = useState({
    joinedon: getQuery("joined_on_sort") ?? "",
    completedTicket: getQuery("completed_tickets_sort") ?? "",
    completedTrips: getQuery("completed_trips_sort") ?? "",
  });
  const [isLoading, setisLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const idParam = getQuery("id");

  const [riderId, setRiderId] = useState(idParam || "");
  const [riderName, setRiderName] = useState("");
  const { pathname } = useLocation();

  const allowed_permissions = useSelector(
    (store) => store.rolePermission.allowed_permissions
  );

  const permissions = allowed_permissions[pathname];

  // dialog state
  const [conformationDialog, setConformationDialog] = useState({
    delete: false,
    block: false,
  });

  const tab = getQuery("tab");
  const [accountStatus, setAccountStatus] = useState(() => {
    if (permissions) {
      return tab || permissions?.SUB_SECTIONS[0];
    } else {
      return tab || "ACTIVE";
    }
  });

  // State for managing the filter
  const [date, setDate] = useState({
    startDate: getQuery("joined_on_gte")
      ? dayjs(getQuery("joined_on_gte"))
      : null,
    endDate: getQuery("joined_on_lte")
      ? dayjs(getQuery("joined_on_lte"))
      : null,
  });

  const [joinedon, setJoinedOn] = useState(getQuery("joined_on") ?? "");
  const [ticket, setTickets] = useState(getQuery("tickets") ?? "");
  const [trips, setTrips] = useState(getQuery("trips") ?? "");

  const [isblocked, setIsBlocked] = useState("");

  const handleAccountStatus = (status) => {
    setQuery("tab", status);
    setQuery("page", 0);
    setQuery("limit", 15);
    setAccountStatus(status);
  };

  const [showFilter, SetShowFilter] = useState({ right: false });
  const [showSort, SetShowSort] = useState({ right: false });

  const limit = parseInt(getQuery("limit"), 15) || 15;
  const page = parseInt(getQuery("page"), 0) || 0;

  // control mui pagination
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: limit || 10,
    page: page || 0,
  });

  const customerFilter = getQuery("customerdrawer");
  const [showDriverDetails, setDriverDetails] = useState({
    right: customerFilter || false,
  });

  const [gender, setGender] = useState(getQuery("gender") ?? "");

  const [customer, setCustomer] = useState([]);

  // Pagination state
  const [totalCount, setTotalCount] = useState({
    ACTIVE: 0,
    BLOCKED: 0,
    DELETE: 0,
  });

  // Debounce
  const searchDebounce = useDebounce(searchValue, 500);

  const { dateformat, timezone, formatDate } = useSettings();

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const [countycode, setCountryCode] = useState(() => {
    const countryCode = getQuery("country_code");

    if (countryCode) {
      const data = countrylist?.find((res) => res?.value === countryCode);
      return data ?? null;
    }

    return null;
  });

  const handleClick = (event, riderId) => {
    setAnchorEl(event.currentTarget);
    setRiderId(riderId);

    setSearchParams(searchParams, { replace: true });
  };

  const handleConformationDailog = (label, value) => {
    setConformationDialog((prev) => ({ ...prev, [label]: value }));
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const checkQuery = (download) => {
    const query = [];

    if (searchDebounce && searchValue) {
      query.push(`search=${searchDebounce}`);
    }
    if (download) {
      query.push(`is_download=${true}`);
    }

    if (sort?.joinedon) {
      query.push(`joined_on_sort=${sort?.joinedon}`);
    }
    if (sort?.completedTicket) {
      query.push(`completed_ticket_sort=${sort?.completedTicket}`);
    }

    if (sort?.completedTrips) {
      query.push(`completed_trips_sort=${sort?.completedTrips}`);
    }

    if (gender) {
      query.push(`gender=${gender}`);
    }

    if (countycode) {
      const country_code = countries[countycode?.value].phone;
      query.push(`country_code=${country_code}`);
    }

    if (joinedon.length > 0) {
      query.push(`joined_on=${joinedon}`);
    }

    if (date && date.endDate) {
      let startDate = `${date.startDate.year()}-${date.startDate.month()}-${date.startDate.date()}`;
      let endDate = `${date.endDate.year()}-${date.endDate.month()}-${date.endDate.date()}`;
      query.push(`date_gte=${startDate}&date_lte=${endDate}`);
    }

    if (ticket) {
      query.push(`tickets_sort=${ticket}`);
    }

    if (trips) {
      query.push(`trips_sort=${trips}`);
    }

    let qurys = query.length > 1 ? query.join("&") : query.join("");

    return qurys;
  };

  const handleOnChange = (event, newValue) => {
    setCountryCode(newValue);
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setDriverDetails({ ...showDriverDetails, [anchor]: open });
  };

  const toggleCustomerDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    SetShowFilter({ ...showDriverDetails, [anchor]: open });
  };
  const toggleSortDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    SetShowSort({ ...showDriverDetails, [anchor]: open });
  };

  // Function To Fetch Coustomer Data
  const fetchCustomerData = async (alt = "", status) => {
    setisLoading(true);
    let query = checkQuery(status);

    let url = `/crm/rider/?page=${paginationModel.page + 1}&limit=${
      paginationModel.pageSize
    }&account_status=${alt ? alt : accountStatus}&${query}`;
    try {
      await axiosInstance.get(url).then((res) => {
        if (status) {
          if (res) {
            notifyToast.success(
              "Success",
              "file has been successfully sent to your email. Please check your inbox.",
              {
                autoClose: 5000,
              }
            );
          }
          return;
        }

        setCustomer(res?.data?.data?.records ?? []);

        setTotalCount((prev) => ({
          ...prev,
          [accountStatus]: res.data.data.total_count,
        }));
      });
    } catch (error) {
      let message = error?.response?.data?.message;
      if (message) {
        notifyToast.error("Error", message);
      }
    } finally {
      setisLoading(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        field: "phone",
        headerName: "Phone Number",
        renderCell: (params) => {
          if (!params?.value) {
            return "--";
          }

          let phoneNumber = params.value;
          let number = phoneNumber.slice(0, 3) + " " + phoneNumber.slice(3);
          return (
            <>
              <Button
                id={params.id}
                sx={{
                  color: "#043A87",
                  width: "86px",
                  fontWeight: "500",
                  textAlign: "center",
                  fontFamily: "Proxima Nova",
                  fontSize: "13px",
                  textTransform: "capitalize",
                  border: "none",
                  paddingLeft: "30px",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setRiderId(params.id);
                  setQuery("id", params?.id, setSearchParams);
                  setQuery("customerdrawer", true, setSearchParams);
                  let callback = toggleDrawer("right", true);
                  callback(e);
                }}
              >
                {number}
              </Button>
            </>
          );
        },
        flex: 0.7,
      },
      {
        field: "full_name",
        headerName: "Name",
        flex: 0.7,
        renderCell: (params) => {
          if (!params?.value) {
            return "--";
          }

          return (
            <>
              <BootstrapTooltip title={params?.value}>
                <Button
                  id={params.id}
                  sx={{
                    border: "none",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: "vertical",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setRiderId(params.id);

                    setQuery("id", params?.id, setSearchParams);
                    setQuery("customerdrawer", true, setSearchParams);

                    let callback = toggleDrawer("right", true);
                    callback(e);
                  }}
                >
                  <Typography
                    sx={{
                      color: "#043A87",
                      fontFamily: "Proxima Nova",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "13px",
                      textTransform: "capitalize",
                      letterSpacing: "0.26px",
                      fontWeight: "500",
                    }}
                  >
                    {params?.value}
                  </Typography>
                </Button>
              </BootstrapTooltip>
            </>
          );
        },
      },
      {
        field: "nick_name",
        headerName: "Nick name",
        flex: 0.7,
        renderCell: (params) => {
          if (!params?.value) {
            return "--";
          }

          return (
            <>
              <BootstrapTooltip title={params?.value}>
                <Button
                  id={params.id}
                  sx={{
                    border: "none",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: "vertical",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setRiderId(params.id);
                    setQuery("id", params?.id, setSearchParams);
                    setQuery("customerdrawer", true, setSearchParams);
                    let callback = toggleDrawer("right", true);
                    callback(e);
                  }}
                >
                  <Typography
                    sx={{
                      color: "#043A87",
                      fontFamily: "Proxima Nova",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "13px",
                      textTransform: "capitalize",
                      letterSpacing: "0.26px",
                      fontWeight: "500",
                    }}
                  >
                    {params?.value}
                  </Typography>
                </Button>
              </BootstrapTooltip>
            </>
          );
        },
      },
      {
        field: "created_at",
        headerName: `Joined On(${dateformat})`,
        flex: 0.5,
        formatter: {
          created_at: (params) =>
            formatDate(params?.value, timezone, dateformat),
          // time: ( params) => {formatDate(params?.row.created_at, timezone, timeFormat??)},
          rating: (params) => `(${params?.value})`,
          // Add other formatters as needed
        },
        valueGetter: (params) => {
          if (!params.value) {
            return "--";
          }

          return `${formatDate(params?.value, timezone, dateformat)}`;
        },
      },
      {
        field: "email",
        headerName: "Email",
        flex: 1,
        valueGetter: (param) => {
          if (!param.value) {
            return "--";
          }

          return param.value;
        },
      },
      {
        field: "gender",
        headerName: "Gender",
        flex: 0.5,
        valueGetter: (params) => {
          if (!params.value) {
            return "--";
          }
          return params.value;
        },
      },
      {
        field: "tickets",
        headerName: "Tickets",
        flex: 0.5,
        renderCell: (param) => {
          if (
            !param?.row?.open_tickets_count &&
            param?.row?.total_tickets_count
          ) {
            return "--";
          }

          return (
            <BootstrapTooltip
              key={param.row.id}
              title={
                <CustomComponent
                  openTickets={param?.row?.open_tickets_count ?? ""}
                  totalTickets={param?.row?.total_tickets_count ?? ""}
                />
              }
              arrow
              placement="bottom-end"
            >
              <Typography
                variant="h6"
                sx={{
                  color: "var(--Linked, #043A87)",
                  fontFamily: "Proxima Nova",
                  fontSize: "13px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "normal",
                  letterSpacing: "0.26px",
                }}
              >
                {`${param.row.open_tickets_count}/${param?.row?.total_tickets_count}`}
              </Typography>
            </BootstrapTooltip>
          );
        },
      },
      {
        field: "completed_trips_count",
        headerName: "Trips",
        flex: 0.5,
        renderCell: (param) => {
          return (
            <BootstrapTooltip
              key={param.row.id}
              title={
                <TripsComponent
                  completeTrips={validateNumber(
                    param?.row?.completed_trips_count
                  )}
                  cancelledTrips={validateNumber(
                    param?.row?.cancelled_trips_count
                  )}
                  totalTrips={validateNumber(param?.row?.total_trips_count)}
                />
              }
              arrow
              placement="bottom-end"
            >
              <Typography
                variant="h6"
                sx={{
                  color: "var(--Linked, #043A87)",
                  fontFamily: "Proxima Nova",
                  fontSize: "13px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "normal",
                  letterSpacing: "0.26px",
                }}
              >
                {`${param?.row?.completed_trips_count ?? 0}/${
                  param?.row?.cancelled_trips_count ?? 0
                }`}
              </Typography>
            </BootstrapTooltip>
          );
        },
      },
      {
        field: "id",
        headerName: "Action",
        flex: 0.2,
        renderCell: (params) => {
          return (
            <Action
              key={params.id}
              permissionsSubSection={permissions ?? {}}
              params={params}
              toggleDrawer={toggleDrawer}
              setRiderId={setRiderId}
              handleClick={handleClick}
              open={open}
              anchorEl={anchorEl}
              setRiderName={setRiderName}
              handleClose={handleClose}
              uniqueBehavior="specific-behavior"
              handleConformationDailog={handleConformationDailog}
              isblocked={params?.row?.account_status}
              setIsBlocked={setIsBlocked}
            />
          );
        },
      },
    ],
    [
      toggleDrawer,
      setRiderId,
      handleClick,
      open,
      anchorEl,
      handleClose,
      conformationDialog,
      setIsBlocked,
    ]
  );

  // Funtion to handle Delete
  const DeleteRiderById = async (e) => {
    try {
      await axiosInstance.delete(`/crm/rider/${riderId}/`).then((_) => {
        notifyToast.success(
          "Rider Deleted Successfully",
          "rider account has been deleted successfully!"
        );
        fetchCustomerData();
      });
    } catch (error) {
      notifyToast.error("", error);
      console.log("Error while Delete Rider by id", error);
    }
  };

  // Funtion To Block Rider By Id
  const handleBlock = () => {
    let updateData = filterEmptyPropertiesRecursively({
      account_status: isblocked === "ACTIVE" ? "BLOCKED" : "ACTIVE",
    });
    try {
      axiosInstance.patch(`/crm/rider/${riderId}/`, updateData).then((_) => {
        notifyToast.success(
          "Success",
          `The account has been successfully ${
            isblocked === "BLOCKED" ? "unblocked" : "blocked"
          }!`
        );

        fetchCustomerData("ACTIVE");
        if (accountStatus !== "ACTIVE") {
          setAccountStatus("ACTIVE");
        }
      });
    } catch (error) {
      notifyToast.error("Error", error);
      console.log(error, "Error while updating customer");
    }
  };

  // Funtion to handle Block
  const customeDateHandler = (name, value, setState) => {
    setState((prev) => ({ ...prev, [name]: value }));
  };

  // Funtion to Clear All filter
  const handleClear = () => {
    if (joinedon) {
      setJoinedOn("");
    }

    if (date.startDate || date.endDate) {
      setDate({
        startDate: "",
        endDate: "",
      });
    }

    if (countycode) {
      setCountryCode(null);
    }

    if (gender) {
      setGender("");
    }

    if (ticket) {
      setTickets("");
    }

    if (trips) {
      setTrips("");
    }
  };

  // config
  const allowed_sub_sections = permissions?.SUB_SECTIONS ?? [
    "ACTIVE",
    "BLOCKED",
    "DELETE",
    "FLAGGED",
  ];

  const sub_section_to_label = {
    ACTIVE: "Active",
    BLOCKED: "Blocked",
    DELETE: "Delete",
    FLAGGED: "Flagged",
  };

  const tableHeadButtonConfig = allowed_sub_sections?.map((sub_section) => {
    return {
      label: sub_section_to_label[sub_section],
      value: sub_section,
      totalcount: totalCount[sub_section],
      onClick: handleAccountStatus,
    };
  });

  const handleFilterState = (
    name,
    value,
    checked,
    status,
    isSingleSelect = true
  ) => {
    if (status === "clear") {
      setSort((prev) => ({
        ...prev,
        [name]: isSingleSelect ? "" : [],
      }));
      return;
    }

    if (isSingleSelect) {
      // If single select, the value is a string
      if (checked) {
        setSort((prev) => ({
          ...prev,
          [name]: value, // Replace with the selected value (string)
        }));
      } else {
        setSort((prev) => ({
          ...prev,
          [name]: "", // Unchecking clears the selection (set to empty string)
        }));
      }
    } else {
      // For multiple select, the value is an array
      if (checked) {
        setSort((prev) => ({
          ...prev,
          [name]: [...prev[name], value], // Add the new value to the array
        }));
      } else {
        setSort((prev) => ({
          ...prev,
          [name]: prev[name].filter((res) => res !== value), // Remove the unchecked value from the array
        }));
      }
    }
  };

  const customerFilterOptions = [
    {
      summryText: "Joined on",
      state: joinedon,
      filterName: "joined_on",
      setState: setJoinedOn,
      options: [
        { label: "Yesterday", value: "yesterday" },
        { label: "Last Week", value: "last_week" },
        { label: "Last Month", value: "last_month" },
        { label: "Last Year", value: "last_year" },
      ],
      date: {
        customDateState: date,
        customDateHeader: "Custom",
        filterName: ["joined_on_gte", "joined_on_lte"],
        customDateLabel: ["From", "To"],
        customDateName: ["startDate", "endDate"],
        customeDateHandler,
        setState: setDate,
        isoString: true,
        // isDispatch: true,
      },
    },
    {
      type: "select",
      summryText: "Select a Country Code",
      options: countrylist,
      filterName: "country_code",
      state: countycode,
      setState: handleOnChange,
    },
    {
      summryText: "Gender",
      filterName: "gender",
      state: gender,
      setState: setGender,
      options: [
        { label: "Male", value: "MALE" },
        { label: "Female", value: "FEMALE" },
      ],
    },
    {
      summryText: "Tickets",
      state: ticket,
      filterName: "tickets",
      setState: setTickets,
      options: [
        { label: "Max Tickets", value: "max_ticktes" },
        { label: "Min Tickets", value: "min_tickets" },
        { label: "Max Pending", value: "max_pending" },
        { label: "Min Pending", value: "min_pending" },
        { label: "Resolved", value: "resolved" },
      ],
    },
    {
      summryText: "Trips",
      filterName: "trips",
      state: trips,
      setState: setTrips,
      options: [
        { label: "Max Trips", value: "max_trips" },
        { label: "Min Trips", value: "min_trips" },
        { label: "Max Cancelled", value: "max_cancelled" },
        { label: "Min Cancelled", value: "min_cancelled" },
      ],
    },
  ];

  const sortFilterConfig = {
    options: [
      {
        ...joinedonSortObj,
        filterName: "joined_on_sort",
        state: sort?.joinedon ?? [],
      },
      {
        summaryText: "Completed Tickets",
        filterName: "completed_tickets_sort",
        name: "completedTicket",
        state: sort?.completedTicket ?? [],
        options: [
          { label: "Ascending", value: "asc" },
          { label: "Descending", value: "dsc" },
        ],
      },
      {
        summaryText: "Completed Trips",
        name: "completedTrips",
        filterName: "completed_trips_sort",
        state: sort?.completedTrips ?? [],
        options: [
          { label: "Ascending", value: "asc" },
          { label: "Descending", value: "dsc" },
        ],
      },
    ],
    handleClearState: () => {},
    handleFilterState: handleFilterState,
  };

  const buttonConfig = {
    active: accountStatus,
    buttonConfig: tableHeadButtonConfig,
    totalCount: {
      ACTIVE: totalCount["ACTIVE"],
      BLOCKED: totalCount["BLOCKED"],
      DELETE: totalCount["DELETE"],
    },
  };

  const handleDownload = () => {
    fetchCustomerData("", "download");
  };

  useEffect(() => {
    fetchCustomerData();
  }, [
    paginationModel.page,
    paginationModel.pageSize,
    searchDebounce,
    accountStatus,
    gender,
    ticket,
    trips,
    date.startDate,
    date.endDate,
    joinedon,
    countycode,
    sort,
  ]);

  return (
    <>
      <Box m="20px">
        <SearchActionComponent
          value={searchValue}
          setState={setSearchValue}
          require={{ search: true, filter: true, download: true, sort: false }}
          toggleDrawer={toggleCustomerDrawer}
          toggleSortDrawer={toggleSortDrawer}
          downloadFile={handleDownload}
        />

        <FilteredResults options={customerFilterOptions} />

        <CommonTableHead
          active={buttonConfig?.active}
          ButtonConfig={buttonConfig?.buttonConfig}
          totalcount={buttonConfig?.totalCount}
        />

        <DataTable
          key={accountStatus}
          row={customer || []}
          columns={columns}
          sx={{ cursor: "pointer" }}
          paginationModel={paginationModel}
          loading={isLoading}
          setPaginationModel={setPaginationModel}
          totalCount={Math.ceil(totalCount[accountStatus])}
        />
      </Box>

      {showDriverDetails.right && (
        <SwipeableDrawerComponent
          isOpen={showDriverDetails["right"]}
          anchor="right"
          onClose={(e) => {
            removeQuery("customerdrawer", setSearchParams);
            removeQuery("id", setSearchParams);
            toggleDrawer("right", false)(e);
          }}
          ModalProps={{
            style: {
              zIndex: 1800,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            },
          }}
        >
          <CustomerDetails
            toggleDrawer={toggleDrawer}
            anchor={"right"}
            riderId={riderId}
            setRiderId={setRiderId}
            fetchFunction={fetchCustomerData}
          />
        </SwipeableDrawerComponent>
      )}

      {showFilter.right && (
        <SwipeableDrawerComponent
          isOpen={showFilter["right"]}
          onClose={toggleCustomerDrawer("right", false)}
          anchor="right"
        >
          <CustomFilter
            filterOptions={customerFilterOptions}
            toggleDrawer={toggleCustomerDrawer}
            handleClear={handleClear}
          />
        </SwipeableDrawerComponent>
      )}
      {showSort.right && (
        <SwipeableDrawerComponent
          isOpen={showSort["right"]}
          onClose={toggleSortDrawer("right", false)}
          anchor="right"
        >
          <SortPanel
            filterOptions={customerFilterOptions}
            toggleDrawer={toggleSortDrawer}
            sortOptions={sortFilterConfig?.options}
            handleClear={handleClear}
            setState={setSort}
          />
        </SwipeableDrawerComponent>
      )}

      <CustomConfirmationDialog
        open={conformationDialog?.delete}
        isGroup={true}
        message={`Are you sure you want to delete ${riderName}`}
        status="delete"
        deleteById={DeleteRiderById}
        handleState={handleConformationDailog}
      />

      <CustomConfirmationDialog
        open={conformationDialog?.block}
        isGroup={true}
        message={`Are you Sure you Want to ${
          isblocked !== "ACTIVE" ? "unblock" : "block"
        } ${riderName}`}
        status="block"
        blockById={handleBlock}
        handleState={handleConformationDailog}
      />
    </>
  );
};

export default Customers;
